import React from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import Suspense from '@atlaskit/react-ufo/suspense';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import { AtlassianRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

const LoadingFallback = () => (
	<Skeleton
		height={token('space.400')}
		width="120px"
		isShimmering
		borderRadius={token('radius.small')}
	/>
);

export const AgentVersionPickerBoundary = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => (
	<ErrorBoundary fallback={null}>
		<AtlassianRelayEnvironmentProvider>
			<Suspense
				interactionName="rovo-conversation-assistant-agent-version-picker"
				fallback={<LoadingFallback />}
			>
				{children}
			</Suspense>
		</AtlassianRelayEnvironmentProvider>
	</ErrorBoundary>
);
